import React from 'react'

function Header() {
  return (
    <div style={{fontSize: 35, color: "grey", fontWeight: "bold", color: '#BF86BF'}}>Notes App</div>
  )
}

export default Header;